<div class="flex justify-between items-center">
  <div class="flex items-center gap-2">
    <app-link (click)="resultTableService.toggleSidebar()" class="border-r border-default" id="results-toggle-search-filters" title="Toggle filters">
      <app-icons icon="filter" svgClass="mr-2" width="20"></app-icons>
    </app-link>

    <span>{{ getSearch() }}</span>

    <app-link href="lookup" title="Change search details" id="results-change-search-details">
      <app-icons icon="pen-to-square" svgClass="" width="20"></app-icons>
    </app-link>

    @if (lookupStore.vehicle.selected_fitment()) {
      <app-link (click)="alternateFitmentsModalOpen.set(true)" id="results-alternate-fitments">
        <app-icons icon="plus-minus" svgClass="" width="20"></app-icons>
      </app-link>

      <app-alternate-fitments-modal [(isOpen)]="alternateFitmentsModalOpen" (onSubmitSearch)="onAlternateSizeSearch($event)"/>
    }
  </div>

  <div class="flex items-center gap-2">
    <app-button size="x-small" variant="secondary" (click)="doFeedback()" class="hidden lg:block" id="results-feedback-button">
      Feedback
    </app-button>

    <app-link (click)="tourService.start('results')" title="Show tour" class="hidden lg:block" id="results-tour">
      <app-icons icon="info-circle" width="20"></app-icons>
    </app-link>

    @if (settingsVisible()) {
      <app-link href="settings" [extras]="{queryParams: {returnTo: 'results'}}" [disabled]="settingsDisabled()" [title]="access.getTitle('edit_settings', 'Open settings')" id="results-settings-cog" class="hidden lg:block">
        <app-icons icon="gear" width="20"></app-icons>
      </app-link>
    }
  </div>
</div>
